var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRouteMarkerA(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 35,
    viewBox: "0 0 25 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 33.4766C11.9449 33.1183 11.558 32.6562 11.1124 32.1071C9.97684 30.708 8.46441 28.7497 6.95396 26.511C5.4416 24.2695 3.94356 21.7649 2.82667 19.2718C1.7039 16.7656 1 14.3445 1 12.25C1 6.02979 6.02978 1 12.25 1C18.4702 1 23.5 6.02979 23.5 12.25C23.5 14.3445 22.7961 16.7656 21.6733 19.2718C20.5564 21.7649 19.0584 24.2695 17.546 26.511C16.0356 28.7497 14.5232 30.708 13.3876 32.1071C12.942 32.6562 12.5551 33.1183 12.25 33.4766Z",
    fill: "white",
    stroke: "#217292",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5488 8.14551L8.90137 19H6.34375L11.125 6.20312H12.7598L12.5488 8.14551ZM15.5986 19L11.9336 8.14551L11.7139 6.20312H13.3574L18.165 19H15.5986ZM15.4316 14.2451V16.1523H8.56738V14.2451H15.4316Z",
    fill: "#217292"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRouteMarkerA);
export default __webpack_public_path__ + "static/media/route-marker-a.45cf6e370522e547c8bd406f611b3739.svg";
export { ForwardRef as ReactComponent };